import Swiper from "swiper/bundle";
import { sliderThumbs } from "../sustainability";
export default function momentsJs() {
	const Moments = document.querySelector(".moments");
	var moments = new Swiper(Moments, {
		spaceBetween: 10,
		slidesPerView: 2,
		freeMode: true,
		watchSlidesProgress: true,
		breakpoints: {
			640: {
				slidesPerView: 3,
			},
			1560: {
				slidesPerView: 4,
			},
		},
	});
	const Moment = document.querySelector(".moment");
	var moment = new Swiper(Moment, {
		spaceBetween: 10,
		thumbs: {
			swiper: moments,
		},
		navigation: {
			nextEl: ".VesselsName-next",
			prevEl: ".VesselsName-prev",
		},
	});

	// sliderThumbs(".moments", moment);

	MouseOver();

	function MouseOver() {
		let isDragging = false;
		const body = document.querySelector("body");
		const newElement = document.createElement("div");
		newElement.innerHTML =
			'<div class=" relative flex gap-x-6 col-[1_/_-2] justify-self-end lg:justify-self-start lg:col-[3_/_span_1] translate-y-full lg:translate-y-0 z-10"><div class="VesselsName-prev flex items-center justify-center w-[calc(25_/_16_*_1rem)] aspect-square rounded-full invert lg:invert-0" tabindex="0" role="button" aria-label="Previous slide" aria-controls="swiper-wrapper-5e8eeb15d8d1fc25" aria-disabled="false" style="opacity: 1;"><img class=" -scale-75 lg:-scale-100 relative" src="../../images/arrow-right.svg" alt="prev slide"></div><div class="VesselsName-next flex items-center justify-center w-[calc(25_/_16_*_1rem)] aspect-square rounded-full invert lg:invert-0" tabindex="0" role="button" aria-label="Next slide" aria-controls="swiper-wrapper-5e8eeb15d8d1fc25" aria-disabled="false" style="opacity: 1;"><img class="scale-75 lg:scale-100" src="../../images/arrow-right.svg" alt="next slide"></div></div>';
		newElement.classList.add("mouseFollow");
		newElement.style =
			"display: none;position: fixed;z-index: 100;pointer-events: none;transform: translate(-50%, -50%);";
		body.append(newElement);

		function detectMousePosition(event) {
			// Get the mouse position from the event object
			const mouseX = event.clientX;
			const mouseY = event.clientY;

			// Check if the mouse button is pressed and set the dragging flag accordingly
			if (event.type === "mousedown") {
				isDragging = true;
			} else if (event.type === "mouseup") {
				isDragging = false;
			}

			// Check if the mouse is dragging or just moving without dragging
			if (isDragging) {
				newElement.style.left = `${mouseX}px`;
				newElement.style.top = `${mouseY}px`;
			} else {
				newElement.style.left = `${mouseX}px`;
				newElement.style.top = `${mouseY}px`;
			}
		}

		Moment.addEventListener("mouseenter", () => {
			console.log("entered");
			newElement.style.display = "block";
			Moment.addEventListener("mousedown", detectMousePosition);
			Moment.addEventListener("mousemove", detectMousePosition);
			Moment.addEventListener("mouseup", detectMousePosition);
		});
		Moment.addEventListener("mouseleave", () => {
			newElement.style.display = "none";
			Moment.removeEventListener("mousedown", detectMousePosition);
			Moment.removeEventListener("mousemove", detectMousePosition);
			Moment.removeEventListener("mouseup", detectMousePosition);
		});
	}
}
